import type { CharacterKind } from './characterConfig';
import type { ToolId } from './toolConfig';

export type LevelId = 'calm' | 'bridge' | 'cat' | 'panda' | 'duck' | 'storm' | 'debris' | 'multi';

export interface LevelDefinition {
  id: LevelId;
  index: number;
  name: string;
  eyebrow: string;
  description: string;
  riverSpeed: number;
  wind: number;
  rescueTime: number;
  distance: number;
  obstacles: number;
  storm: boolean;
  characters?: CharacterKind[];
  recommended: ToolId | 'observe';
  rescueCount?: number;
}

export const LEVELS: LevelDefinition[] = [
  {
    id: 'calm',
    index: 1,
    name: '平静的小河',
    eyebrow: '新手热身',
    description: '水流缓慢，距离较近。先把救生圈扔准。',
    riverSpeed: 0.75,
    wind: 0.15,
    rescueTime: 15,
    distance: 7.5,
    obstacles: 0,
    storm: false,
    characters: ['man', 'woman', 'young', 'tourist'],
    recommended: 'lifeRing',
  },
  {
    id: 'bridge',
    index: 2,
    name: '桥下急流',
    eyebrow: '桥墩警告',
    description: '急流与桥墩让绳索变得难以控制。',
    riverSpeed: 2.4,
    wind: 0.5,
    rescueTime: 15,
    distance: 10,
    obstacles: 3,
    storm: false,
    recommended: 'lifeRing',
  },
  {
    id: 'cat',
    index: 3,
    name: '落水的橘猫',
    eyebrow: '它不配合',
    description: '猫会躲开飞来的东西，救援杆更加稳妥。',
    riverSpeed: 1.2,
    wind: 0.25,
    rescueTime: 14,
    distance: 6,
    obstacles: 1,
    storm: false,
    characters: ['orangeCat'],
    recommended: 'rescuePole',
  },
  {
    id: 'panda',
    index: 4,
    name: '熊猫太重了',
    eyebrow: '重量级选手',
    description: '普通救生圈吃力，完整充气的小船更可靠。',
    riverSpeed: 1.5,
    wind: 0.25,
    rescueTime: 18,
    distance: 11,
    obstacles: 1,
    storm: false,
    characters: ['panda'],
    recommended: 'inflatableBoat',
  },
  {
    id: 'duck',
    index: 5,
    name: '鸭子需要救吗',
    eyebrow: '判断力测试',
    description: '先观察。错误干预可能只是给鸭子添麻烦。',
    riverSpeed: 1.35,
    wind: 0.3,
    rescueTime: 12,
    distance: 8,
    obstacles: 0,
    storm: false,
    characters: ['duck'],
    recommended: 'observe',
  },
  {
    id: 'storm',
    index: 6,
    name: '暴雨天气',
    eyebrow: '能见度下降',
    description: '阵风会改变投掷轨迹，水流还在持续变化。',
    riverSpeed: 2.85,
    wind: 1.4,
    rescueTime: 16,
    distance: 11.5,
    obstacles: 2,
    storm: true,
    recommended: 'rope',
  },
  {
    id: 'debris',
    index: 7,
    name: '漂浮垃圾',
    eyebrow: '河道障碍赛',
    description: '树枝、轮胎和木箱都在顺流移动。',
    riverSpeed: 2.1,
    wind: 0.65,
    rescueTime: 17,
    distance: 12,
    obstacles: 7,
    storm: false,
    recommended: 'lifeVest',
  },
  {
    id: 'multi',
    index: 8,
    name: '连续救援',
    eyebrow: '三人轮番落水',
    description: '连续救援三名角色，已成功使用的工具将被消耗。',
    riverSpeed: 1.9,
    wind: 0.55,
    rescueTime: 20,
    distance: 9.5,
    obstacles: 3,
    storm: false,
    recommended: 'lifeRing',
    rescueCount: 3,
  },
];

export const getLevel = (id: string): LevelDefinition =>
  LEVELS.find((level) => level.id === id) ?? LEVELS[0];
